import 'prop-types';
import { memo } from 'react';
import { Text } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
function PaymentError(_ref) {
  let {
    className
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    className: className,
    "data-cmp": "paymentErrorMessage",
    children: [/*#__PURE__*/jsx(Text, {
      color: "danger",
      weight: "bold",
      children: "We're unable to calculate a payment.\xA0"
    }), /*#__PURE__*/jsx(Text, {
      color: "danger",
      children: "Try selecting a different payment type or editing your offer terms."
    })]
  });
}
var PaymentError$1 = /*#__PURE__*/memo(PaymentError);
export { PaymentError$1 as default };
